import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-700850ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article mx-auto pt-4 row" }
const _hoisted_2 = { class: "col-12 col-sm-8 col-xl-4 article__image-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-2" }, "view image", -1))
const _hoisted_6 = { class: "col-12 col-sm-4 col-xl-4 d-flex flex-column justify-content-start justify-content-xl-between align-items-start" }
const _hoisted_7 = { class: "article__naming" }
const _hoisted_8 = { class: "heading-1 mb-sm-4" }
const _hoisted_9 = { class: "subhead-1" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col-12 col-xl-4 article__info" }
const _hoisted_12 = { class: "display" }
const _hoisted_13 = { class: "article__info-p" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePictureModal = _resolveComponent("BasePictureModal")!
  const _component_ImageSlider = _resolveComponent("ImageSlider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "image-large",
          src: _ctx.currentPainting.imageLarge,
          alt: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleImage && _ctx.toggleImage(...args))),
          class: "image-link d-flex gap-3 p-3"
        }, [
          _createElementVNode("img", {
            src: _ctx.icon,
            alt: ""
          }, null, 8, _hoisted_4),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.currentPainting.title), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.currentPainting.author), 1)
        ]),
        _createElementVNode("img", {
          class: "image-portrait",
          src: _ctx.currentPainting.portrait,
          alt: ""
        }, null, 8, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.currentPainting.year), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, _toDisplayString(_ctx.currentPainting.description), 1)
        ]),
        _createElementVNode("a", {
          class: "wiki",
          href: _ctx.currentPainting.source,
          target: "_blank"
        }, "go to source", 8, _hoisted_14)
      ])
    ]),
    (_ctx.isImageVisible)
      ? (_openBlock(), _createBlock(_component_BasePictureModal, {
          key: 0,
          onClose: _ctx.toggleImage,
          img: _ctx.currentPainting.imageLarge
        }, null, 8, ["onClose", "img"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ImageSlider, {
      index: _ctx.slideWidth,
      next: _ctx.nextRoute,
      prev: _ctx.prevRoute,
      id: _ctx.currentPainting.id,
      title: _ctx.currentPainting.title,
      author: _ctx.currentPainting.author
    }, null, 8, ["index", "next", "prev", "id", "title", "author"])
  ], 64))
}